import { Component, input, output } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TemplateSlot } from '../../../interfaces';
import { SlotType } from '../../../enums';
import { SlotInlineCheckboxComponent } from '../slot-inline-checkbox/slot-inline-checkbox.component';
import { SlotInlineRadioButtonComponent } from '../slot-inline-radio-button/slot-inline-radio-button.component';
import { SlotInputComponent } from '../slot-input/slot-input.component';
import { SlotTileOptionalInputComponent } from '../slot-tile-optional-input/slot-tile-optional-input.component';
import { SlotTileCheckboxComponent } from '../slot-tile-checkbox/slot-tile-checkbox.component';
import { SlotTileRadioButtonComponent } from '../slot-tile-radio-button/slot-tile-radio-button.component';
import { SlotNumericStepperComponent } from '../slot-numeric-stepper/slot-numeric-stepper.component';
import { SlotDropdownComponent } from '../slot-dropdown/slot-dropdown.component';
import { SlotMultiselectDropdownComponent } from '../slot-multiselect-dropdown/slot-multiselect-dropdown.component';

@Component({
    selector: 'ca-template-slot',
    templateUrl: './template-slot.component.html',
    styleUrls: ['./template-slot.component.scss'],
    imports: [
        FormsModule,
        TranslateModule,
        SlotNumericStepperComponent,
        SlotInlineCheckboxComponent,
        SlotTileCheckboxComponent,
        SlotInlineRadioButtonComponent,
        SlotTileRadioButtonComponent,
        SlotInputComponent,
        SlotTileOptionalInputComponent,
        SlotDropdownComponent,
        SlotMultiselectDropdownComponent
    ]
})
export class TemplateSlotComponent {
    slot = input.required<TemplateSlot>();
    slotIndex = input.required<number>();
    questionBlockId = input.required<string>();
    devMode = input<boolean>(false);
    questionBlockValidations = input<any[]>();
    value = input.required<any>();
    form = input.required<FormGroup>();
    markAsTouched = input<boolean>(false);
    valueChange = output<any>();

    readonly slotType = SlotType;
}
